import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Root } from './Root';

dayjs.extend(utc);

const element = document.getElementById('root');
if (element === null) throw new Error('Failed to find root element');
const root = ReactDOM.createRoot(element);

root.render(
    <StrictMode>
        <Root />
    </StrictMode>,
);
